var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.alert)?_c('v-alert',{staticClass:"header-alert",attrs:{"type":"success","dismissible":"","transition":"slide-x-reverse-transition","icon":_vm.alert.icon,"color":_vm.alert.color},on:{"input":_vm.closeAlert}},[_c('h4',[_vm._v(_vm._s(_vm.$t(_vm.alert.title)))]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.alert.subtitle)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }